import React from 'react';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { FormCatMachineSanitary } from './FormCatMachineSanitary';
import { Dialog } from 'primereact/dialog';

export const ModalCatMachineSanitarySanitaria = (props) => {
    const{
        method, modalTitle, loading, modal, toggle,
        handleInputChange, saveCreate, saveUpdate,
        validaciones, descripcion,clave,closeDialog
    }=props;


    return (
        <Dialog header={modalTitle} visible={modal} onHide={closeDialog} closable={true} modal blockScroll className='medium-dialog'>
            {
                method === "create"
                ?<FormCatMachineSanitary
                    button = {ModalButtonSave}
                    {...{closeDialog, loading, handleInputChange, validaciones, methodAction: saveCreate,}}
                />
                :
                (method === "update")
                ?
                <FormCatMachineSanitary
                    button={ModalButtonUpdate}
                    {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, descripcion,clave}}
                />
                :
                null
            }
        </Dialog>
    )
}